export default class AgreementsModule {

    container = document.querySelector('.reservation-agreements');
    checkbox = {
        checkAll: null,
        acceptRegulations: false,
        allowPhoneNumber: false,
        allowEmail: false
    };

    constructor() {
        this.setCheckboxes();
        this.bindCheckAllCheckbox();
        this.bindRegulationsCheckbox();
        this.bindToogleButton();
    }

    setCheckboxes = () => {
        const { checkbox } = this;

        for (const inputId in checkbox) {
            checkbox[inputId] = document.getElementById(inputId);

            if (checkbox[inputId] !== null) {
                checkbox[inputId].addEventListener('change', () => {
                    if (
                        checkbox.acceptRegulations.checked
                        && (checkbox.allowEmail === null || checkbox.allowEmail.checked)
                        && (checkbox.allowPhoneNumber === null || checkbox.allowPhoneNumber.checked)
                    ) {
                        checkbox.checkAll.checked = true;
                    } else {
                        checkbox.checkAll.checked = false;
                    }
                });
            }
        }
    }

    bindCheckAllCheckbox = () => {
        const { checkbox } = this;

        checkbox.checkAll.addEventListener('click', () => {
            for (const inputId in checkbox) {
                if (checkbox[inputId] !== null) {
                    checkbox[inputId].checked = checkbox.checkAll.checked;
                }
            }
        });
    }

    bindRegulationsCheckbox = () => {
        this.checkbox.acceptRegulations.addEventListener('click', () => {
            if (this.checkbox.acceptRegulations.checked) {
                this.checkbox.acceptRegulations.classList.remove('error');
            }
        });
    }

    bindToogleButton = () => {
        const hideContainer = this.container.querySelector('.reservation-agreements__hide');
        const buttonsToggle = document.getElementById('agreementToggleButton');

        buttonsToggle.addEventListener('click', () => {
            hideContainer.classList.toggle('show');
        });
    }
}